if (!customElements.get('featured-blog-slider')) {
  customElements.define(
    'featured-blog-slider',
    class FeaturedBlogSlider extends HTMLElement {
      // Slider on mobile and tablet; from 990px up the posts stay in the CSS grid, so Swiper is
      // created and destroyed as the viewport crosses the breakpoint.
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 989px)');
        this.onBreakpointChange = this.update.bind(this);
        this.mediaQuery.addEventListener('change', this.onBreakpointChange);
        this.update();
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
        this.destroySwiper();
      }

      update() {
        if (this.mediaQuery.matches) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }

      initSwiper() {
        if (this.swiper || typeof Swiper === 'undefined') return;

        const viewport = this.querySelector('[data-slider-viewport]');
        if (!viewport) return;

        this.swiper = new Swiper(viewport, {
          // Theme class names, so swiper-bundle.min.css isn't needed. Other sections reuse this
          // slider by passing their own class names via data-wrapper-class / data-slide-class.
          wrapperClass: this.dataset.wrapperClass || 'featured-blog__grid',
          slideClass: this.dataset.slideClass || 'featured-blog__item',
          slidesPerView: 1.15,
          spaceBetween: 16,
          watchOverflow: true,
          grabCursor: true,
          breakpoints: {
            430: { slidesPerView: 1.6, spaceBetween: 16 },
            750: { slidesPerView: 2.2, spaceBetween: 20 },
          },
        });
      }

      destroySwiper() {
        if (!this.swiper) return;
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
